module.exports = __webpack_public_path__ + "static/jahswill2-7d5f753a75bc7d80b9ded999081e60a8.png";